module.exports = __webpack_public_path__ + "static/media/mignons-contact-home-page.d1da38b3.png";